import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconText } from 'components/core/IconText';
import { Text } from 'components/core/Text';
import {
	PenskeRental,
	TruckRental,
	FreeTruckRental
} from 'components/svg';

const truckTypes = {
	penskeRental: {
		imgSrc: PenskeRental,
		text: 'Penske truck available with storage rental'
	},
	truckRental: {
		imgSrc: TruckRental,
		text: 'Truck available with storage rental'
	},
	freeTruckRental: {
		imgSrc: FreeTruckRental,
		text: 'Free truck available with storage rental'
	}
};

export default function TruckPromo({ truckType, className }) {
	return (
		<IconText
			className={classnames('truck-promo', className)}
			icon={truckTypes[truckType].imgSrc}
			type="info"
		>
			<Text>
				{truckTypes[truckType].text}
			</Text>
		</IconText>
	);
}

TruckPromo.propTypes = {
	truckType: PropTypes.oneOf(['penskeRental', 'truckRental', 'freeTruckRental']),
	className: PropTypes.string
};
